import { Usuario, GroupList } from './usuario';

export interface Preference extends Usuario {
  userId?: string;
}

export class PreferenceObject implements Preference {
  userId?: string;
  auditoria?: boolean;
  avisos?: boolean;
  notifyToken?: { [key: string]: string };
  notifyTokens?: string[];
  email?: string;
  provider?: string;
  providerPassword?: boolean;
  providerGoogle?: boolean;
  providerFacebook?: boolean;
  image?: string;
  showImage: boolean;
  name?: string;
  emailVerified?: boolean;
  grupoSelecionado?: string;
  grupos?: GroupList;
  convites?: GroupList;
}

export interface PreferencesUsers {
  [userId: string]: Usuario;
}

export enum ProviderEnum {
  Email = 'email',
  Password = 'password',
  Google = 'google.com',
  Facebook = 'facebook.com',
}
